export default {
    fieldValidation: {
        pcnMin: 'Minimum of 10 numbers',
        pcnMax: 'Maximum of 16 numbers',
        onlyNumbers: 'Only Numbers',
        pcnReq: 'PCN Number is required',
        vrmReq: 'VRN is required',
        vrmInvalid: 'VRN is invalid',
        pcnPrefixError: 'Please check your PCN Number - prefix and suffix',
    },
    home: {
        pcn: "PCN Number",
        lookup: "Submit",
        title: "PCN Payments",
        vrm: "VRN",
    },
    items: {
        pcn: "PCN Number",
        lookup: "Submit",
        title: "PCN Payments",
        vrm: "VRN",
        stepOneMessageP1: "Vehicle registration numbers (VRN) and penalty charge notices (PCN) ",
        stepOneMessageP2: "MUST",
        stepOneMessageP3: " be entered in the correct format (LJ). Please check your VRN and PCN carefully before" +
            " entry. The most common mistake made by vehicles owners which result in an error" +
            " message, is that letters such as \"O\" and \"I\" are entered as the numbers zero [0]" +
            " or one [1] or vice versa.",
        vrmNumber: "VRN Number",
    }
}
